import React from "react";
import { Avatar } from "antd";

const colors = [
  {
    background: "#FFE0BF",
    text: "#FF8400",
  },
  {
    background: "#C3DEED",
    text: "#0E7AB7",
  },
  {
    background: "#F5E1F9",
    text: "#D687E6",
  },
  {
    background: "#D1E9F1",
    text: "#48A8C7",
  },
  {
    background: "#FAD5D5",
    text: "#EB5757",
  },
  {
    background: "#DBF3E5",
    text: "#6FCF97",
  },
  {
    background: "#BFE2FF",
    text: "#008DFF",
  },
  {
    background: "#DFDFE1",
    text: "#817F87",
  },
  {
    background: "#FCF1D2",
    text: "#F2C94C",
  },
  {
    background: "#D5F2FC",
    text: "#56CCF2",
  },
];

const getColorPaletteByName = (name) => {
  const defaultColors = {
    background: "#BFE2FF",
    text: "#008DFF",
  };

  if (name === null) {
    return defaultColors;
  }

  try {
    let char = name.substr(0, 1);
    const nameArr = name.split(" ");

    if (nameArr.length > 0) {
      const lastIndexData = nameArr[nameArr.length - 1];
      if (lastIndexData != null) {
        char = lastIndexData.charAt(lastIndexData.length - 1);

        char = lastIndexData.charAt(lastIndexData.length - 1);
      }
    }
    char = char.toLowerCase();

    const charList = {
      a: 0,
      b: 1,
      c: 2,
      d: 3,
      e: 4,
      f: 5,
      g: 6,
      h: 7,
      i: 8,
      j: 9,
      k: 1,
      l: 0,
      m: 1,
      n: 2,
      o: 3,
      p: 4,
      q: 5,
      r: 6,
      s: 7,
      t: 8,
      u: 9,
      v: 1,
      w: 0,
      x: 1,
      y: 2,
      z: 3,
      0: 2,
      1: 0,
      2: 5,
      3: 5,
      4: 8,
      5: 6,
      6: 9,
      7: 7,
      8: 3,
      9: 1,
    };

    const index = charList[char];
    const color = colors[index];

    if (color != null) {
      return color;
    }
    return defaultColors;
  } catch (e) {}

  return defaultColors;
};

const UIAvatar = ({ size, src, icon, name }) => {
  const colors = getColorPaletteByName(name);
  return (
    <Avatar
      style={{
        color: colors.text,
        backgroundColor: colors.background,
      }}
      src={src ? src : null}
      size={size}
      icon={icon}
    >
      {name?.match(/\b(\w)/g)?.join("")}
    </Avatar>
  );
};

export default UIAvatar;
